import { channelConstants } from '../actions/constants/channelConstants';

const initialChannel = {
	items: [],
	favChannelData: [],
	nonFavChannelData: []
}

const channelData = (state = initialChannel, action: any) => {
	switch (action.type) {
		case channelConstants.ChannelGetByfilterRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
			};
		case channelConstants.ChannelGetByfilterSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isListSuccess: true,
				items: (action.payload !== "" && action.payload !== null) ? action.payload.channels : []
			};
		case channelConstants.ChannelGetByfilterFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isListSuccess: true,
				status: action.payload
			};

		case channelConstants.ChannelGetAllRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isListSuccess: false,
				isSuccess: false,
			};
		case channelConstants.ChannelGetAllSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isListSuccess: true,
				items: (action.payload !== "" && action.payload !== null) ? action.payload.channels : []
			};
		case channelConstants.ChannelGetAllFailure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isListSuccess: true,
				isSuccess: false,
			};

		case channelConstants.ChannelDetailRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case channelConstants.ChannelDetailSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				channelInput: action.payload.channel
			};
		case channelConstants.ChannelDetailFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload
			};

		case channelConstants.ChannelSaveRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
			};
		case channelConstants.ChannelSaveSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				status: action.payload.status,
				channel: action.payload.channel
			};
		case channelConstants.ChannelSaveFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload
			};

		case channelConstants.ChannelDeleteRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false
			};
		case channelConstants.ChannelDeleteSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDeleteCompleted: true,
				status: action.payload.status
			};
		case channelConstants.ChannelDeleteFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDeleteCompleted: true,
				status: action.payload
			};

		case channelConstants.ChannelFaviruteRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isFavChannelLoaded: false
			};
		case channelConstants.ChannelFaviruteSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isFavChannelLoaded: true,
				status: action.payload.status,
				favChannelData: action.payload
			};
		case channelConstants.ChannelFaviruteFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isFavChannelLoaded: true,
				favChannelData:[],
				status: action.payload
			};

		case channelConstants.ChannelnonFaviruteRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isnonFavChannelLoaded: false
			};
		case channelConstants.ChannelnonFaviruteSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isnonFavChannelLoaded: true,
				status: action.payload.status,
				nonFavChannelData: action.payload
			};
		case channelConstants.ChannelnonFaviruteFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isnonFavChannelLoaded: true,
				nonFavChannelData:[],
				status: action.payload
			};
		default:
			return state;
	}
};

export default channelData;
